export default {
  DARK: {
    border: () => 'none',
    shadow: () => 'none',
    buttonShadow: () => 'none',
    paragraph: p => p.accentWhite,
    background: p => p.tertiaryDark,
    lightBackground: p => p.tertiaryExtraLight,
    backgroundColor: p => p.tertiaryDark,
    navbarBg: p => p.tertiaryDark,
    borderColor: p => p.accentWhite
  },
  LIGHT: {
    paragraph: p => p.primaryDark,
    background: p => p.tertiaryLight,
    lightBackground: p => p.tertiaryExtraLight,
    backgroundColor: p => p.tertiaryLight,
    navbarBg: p => p.tertiaryLight,
    borderColor: p => p.tertiaryDark
  },
  EXTRALIGHT: {
    paragraph: p => p.tertiaryDark,
    background: p => p.tertiaryExtraLight,
    lightBackground: p => p.tertiaryExtraLight,
    backgroundColor: p => p.tertiaryExtraLight,
    navbarBg: p => p.tertiaryExtraLight,
    borderColor: p => p.accentwhite
  }
}
